import './PaymentTable.css';
import { Typography } from '@mui/material';
import DataTable from '../../components/dataTable/DataTable';

export default function PaymentTable() {
  return (
    // React Fragment - we need it to surround temporarily  
    // several separate elements
    <div className="paymentTable">

      <Typography component='h3' variant='h3'>תשלומים</Typography>

      <DataTable what="payment" />

    </div>
  )
}
